import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-background-50 hover:text-primary-200 transition-colors mb-4"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold whitespace-nowrap">
                Hipobuy Sheet
              </span>
            </Link>
            <p className="text-xs md:text-sm text-background-50/50 leading-relaxed">
              The ultimate product discovery database and shopping research platform.
              Helping thousands of shoppers find, compare, and discover products
              through organized spreadsheet categories.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/40 uppercase tracking-widest mb-4">
              Quick Links
            </h4>
            <div className="space-y-2.5">
              <Link
                to="/"
                className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/article/what-is-hipobuy-spreadsheet"
                className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Hipobuy Spreadsheet Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Visit kaspreadsheet.com
              </a>
              <Link
                to="/"
                className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                All Categories
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/40 uppercase tracking-widest mb-4">
              Comparisons
            </h4>
            <div className="space-y-2.5">
              {["Hipobuy vs Kakobuy", "Hipobuy vs CSSBuy", "Hipobuy vs Superbuy", "Hipobuy vs Oopbuy", "All Comparisons"].map(
                (item) => (
                  <Link
                    key={item}
                    to="/"
                    className="block text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {item}
                  </Link>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-background-50/40 uppercase tracking-widest mb-4">
              Stay Updated
            </h4>
            <p className="text-xs text-background-50/50 mb-4">
              Get the latest product discoveries and spreadsheet updates.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-background-50 bg-primary-600 hover:bg-primary-500 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit Main Site
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Privacy Policy
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Terms of Service
              </a>
            </div>
          </div>

          <div className="mt-10 text-center">
            <span className="font-heading text-6xl md:text-8xl font-bold text-background-50/5 tracking-tighter select-none">
              HIPOBUY
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}